//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.PartOperationBuilder.js";
import "../no/PartCollection.js";
let d=[[[0,"DesignWorksetIntent",1,0]],[[["itemType"],"SetItemType",{},1,0],[["modelType"],"SetModelType",{},1,0],[["masterPart"],"SetMasterPart",{},1,0],[[],"GetOperationSubType",{R_:{dialogOperation:''}},0,0],[["operatioSubType"],"SetOperationSubType",{},1,0],[["addMaster"],"SetAddMaster",{},1,0],[["partsToRename"],"SetPartsToRename",{},1,0],[[],"GetAddMaster",{R_:{addMaster:''}},0,0],[["partSpecToOpen"],"SetPartSpecToOpen",{},1,0],[["seedPartName","numOfPartsToCreate","numLogicalObjects","logicalObjects"],"CreateLogicalObjectsUsingSeedPart",{},2,0],[["numResultPartsSpecs","resultPartsSpecs"],"GetResultPartSpecs",{},0,0]],[]];
SPLM.PDM.PartOperationCreateBuilder = class extends SPLM.PDM.PartOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.PartOperationCreateBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.PartOperationCreateBuilder.OperationSubType = Object.freeze({
    "FromTemplate" : "FromTemplate", "SelectTemplate" : "SelectTemplate", "Rename" : "Rename", "CreateSpecification" : "CreateSpecification", "RenameNativePartInTc" : "RenameNativePartInTc"});

export default SPLM;